import { render } from "./DocumentAccessModal.vue?vue&type=template&id=46e96cd3&scoped=true"
import script from "./DocumentAccessModal.vue?vue&type=script&lang=js"
export * from "./DocumentAccessModal.vue?vue&type=script&lang=js"

import "./DocumentAccessModal.vue?vue&type=style&index=0&id=46e96cd3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e96cd3"]])

export default __exports__